module.exports = function() {
  return new Worker(__webpack_public_path__ + "1a27afe6c0802b38a215.worker.js");
};